import { Middleware, configureStore, combineReducers } from '@reduxjs/toolkit';

import { authApi } from './api/auth';
import { coursesApi } from './api/courses';
import { tenantsApi } from './api/tenants';
import { authReducer } from './slices/auth';
import { projectsApi } from './api/projects';
import { loaderReducer } from './slices/loader';
import { contactUsApi } from './api/contact-us';
import { courseStepsApi } from './api/course-steps';
import { referenceItemsApi } from './api/reference-items';
import { courseEnrollmentsApi } from './api/course-enrollments';
import { courseSubmissionsApi } from './api/course-submissions';
import { courseStepSubmissionsApi } from './api/course-step-submissions';

const apis = [
  authApi,
  coursesApi,
  tenantsApi,
  projectsApi,
  courseStepsApi,
  courseEnrollmentsApi,
  courseSubmissionsApi,
  contactUsApi,
  referenceItemsApi,
  courseStepSubmissionsApi,
];

const appReducer = combineReducers({
  auth: authReducer,
  loader: loaderReducer,
  ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'auth/clearAuth') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apis.map((api) => api.middleware as Middleware)
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
